import React from "react";
import { motion } from "framer-motion";
import { HeartHandshake } from "lucide-react";
import "./SupporterPlan.css";

const SupporterPlan = () => {
  const handleSupportClick = () => {
    window.open('https://buymeacoffee.com/rapidmind', '_blank');
  };

  return (
    <motion.div
      className="pricing-card supporter"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="supporter-icon">
        <HeartHandshake size={48} />
      </div>

      <h2>Supporter</h2>
      <p className="price">$5 / month</p>
      <p className="description">
        Join the <strong>RapidMind Smart AI</strong> journey by becoming a{" "}
        <strong>Supporter</strong> — a special community that helps
        bring intelligent tools to life.
      </p>

      <div className="benefits">
        <h4>🎁 As a thank-you gift, you'll receive:</h4>
        <ul>
          <li>✨ A personalized quick AI service or gift from me</li>
          <li>⚡ Priority response for your ideas or requests</li>
          <li>🤝 Recognition as a valued early supporter</li>
        </ul>
      </div>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="supporter-button"
        onClick={handleSupportClick}
      >
        Join the Membership
      </motion.button>

      <p className="note">
        ❤️ Your support accelerates the development of RapidMind Smart AI.
      </p>
    </motion.div>
  );
};

export default SupporterPlan;
